<template>
  <div class="typeOne">
    <div class="typeOne-item" v-for="(item,index) in technicalCcheme" :key="index">
      <div class="typeOne-title">{{item.title||''}}</div>
      <div class="typeOne-desc">{{item.desc||''}}</div>
      <div class="img-box">
        <div class="img-box-item" v-for="(itemSub,indexSub) in item.imgBox" :key="indexSub">
          <img :src="require(`../assets/${itemSub.imgSrc}`)" >
          <span>{{itemSub.desc || ''}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'typeOne',
    props:{
      technicalCcheme:{
        type:Array,
        default:[]
      }
    }
  }
</script>

<style scoped lang="less">
  .typeOne{
    .typeOne-item{
      padding: 20px 0;
      border-bottom: 10px solid #F9F9F9;
      .typeOne-title{
        font-size: 20px;
        font-weight: bold;
        color: #000;
        text-align: center;
      }
      .typeOne-desc{
        width: 90%;
        margin: 0 auto;
        text-align: center;
        font-size: 12px;
        color: #333333;
        line-height: 26px;
        margin-top: 10px;
      }
      .img-box{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 15px;
        .img-box-item{
          width: 170px;
          text-align: center;
          img{
            display: block;
            width: 100%;
          }
          span{
            display: block;
            font-size: 14px;
            color: #555555;
            margin-top: 5px;
          }
          &:first-child{
            margin-right: 5px;
          }
          &:last-child{
            margin-left: 5px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/typeOne.vue